// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SecurityFeaturesSection_cardContainer__G5NZG","cardBox":"SecurityFeaturesSection_cardBox__MsdxD"};